import { createColumnDate, createColumnInput, createColumnInputNumber, createColumnSelect } from "../../../../../components/table/c-table.logic";
import i18n from "../../../../../i18n";
import store from "../../../../../store";
import { has } from "../../../../../utils/menu-context";
import { callCountry } from "../../../master-mgt/country/country.logic";
import { callDepartment } from "../../../master-mgt/department-responsible/department-responsible.logic";
import { callAquaticType } from "../../../master-mgt/product/product.logic";
import { callSamplingCondition } from "../../company/company.section";

export const createColumns = ({ props }) => {
    let defaultCompanyDepartment = null;
    if (!has({ menuContext: props?.menuContext, key: "canSearchByCompanyDepartment" })) {
        defaultCompanyDepartment =
            store.state.resource.auth.info?.user?.refDepartment?.refParent || store.state.resource.auth.info?.user?.refDepartment;
    }
    const columns = [
        createColumnInput({
            title: () => i18n.global.t("model.company.thNo"),
            dataIndex: "refSamplingRequest.refCompany.thNo",
            align: "center",
            width: 100
        }),
        createColumnInput({ title: () => i18n.global.t("model.company.nameTh"), dataIndex: "refSamplingRequest.refCompany.nameTh" }),
        createColumnSelect({
            title: () => i18n.global.t("model.company.refDepartment"),
            dataIndex: "refSamplingRequest.refCompany.refDepartment.nameTh",
            inputProp: () => ({ list: callDepartment, optLabel: "nameTh" }),
            search: {
                visible: () => has({ menuContext: props?.menuContext, key: "canSearchByCompanyDepartment" }),
                name: "refSamplingRequest.refCompany.refDepartment.id",
                field: { searchValue: defaultCompanyDepartment }
            },
            width: 120
        }),
        createColumnInput({
            title: () => i18n.global.t("model.samplingRequest.requestNo"),
            dataIndex: "refSamplingRequest.requestNo",
            align: "center",
            width: 100
        }),
        createColumnDate({
            title: () => i18n.global.t("model.samplingRequest.samplingCollectDate"),
            dataIndex: "refSamplingRequest.samplingCollectDate",
            align: "center",
            width: 100
        }),
        createColumnInput({ title: () => i18n.global.t("model.samplingProduct.samplingNo"), dataIndex: "samplingNo", align: "center", width: 100 }),
        createColumnInput({
            title: () => i18n.global.t("model.product.code"),
            dataIndex: "refCompanyProduct.refProduct.code",
            align: "center",
            width: 100
        }),
        createColumnInput({ title: () => i18n.global.t("model.product.nameTh"), dataIndex: "refCompanyProduct.refProduct.nameTh" }),
        createColumnSelect({
            title: () => i18n.global.t("views.company.report.labReject.samplingType"),
            dataIndex: "refSamplingRequest.refSamplingRequestType.value",
            inputProp: () => ({ list: callSamplingCondition, optLabel: "value" }),
            search: {
                name: "refSamplingRequest.refSamplingRequestType.id"
            },
            align: "center"
        }),
        createColumnInput({ title: () => i18n.global.t("model.samplingProduct.packageSize"), dataIndex: "packageSize", width: 100 }),
        createColumnSelect({
            title: () => i18n.global.t("model.samplingProduct.exportCountry"),
            dataIndex: "refCountry1.nameEn",
            dataIndexValue: ({ record }) => [record.refCountry1?.nameEn, record.refCountry2?.nameEn].filter(d => d).join(", "),
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            inputProp: () => ({ list: callCountry, optLabel: "nameEn" }),
            search: { name: "refCountry1.id" },
            align: "center",
            width: 100
        }),
        createColumnInputNumber({
            title: () => i18n.global.t("model.samplingProduct.exportAmount"),
            dataIndex: "exportAmount",
            inputProp: () => ({ allowPrecision: true }),
            width: 100
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.product.refAquaticType"),
            dataIndex: "refCompanyProduct.refProduct.refAquaticType.value",
            inputProp: () => ({ list: callAquaticType, optLabel: "value" }),
            search: {
                name: "refCompanyProduct.refProduct.refAquaticType.id"
            },
            align: "center",
            width: 100
        }),
        createColumnInput({
            title: () => i18n.global.t("views.company.report.labReject.labMicro"),
            dataIndex: "micro.analysiss.topics.refLabTopic.name",
            dataIndexValue: ({ record }) =>
                record.analysiss
                    .filter(d => d.refLabType?.key === "labMicro")
                    .flatMap(d => d.topics)
                    .map(d => d.refLabTopic?.name)
                    .filter(d => d)
                    .join(", "),
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            search: { visible: () => false }
        }),
        createColumnInput({
            title: () => i18n.global.t("views.company.report.labReject.labChemi"),
            dataIndex: "chemi.analysiss.topics.refLabTopic.name",
            dataIndexValue: ({ record }) =>
                record.analysiss
                    .filter(d => d.refLabType?.key === "labChemi")
                    .flatMap(d => d.topics)
                    .map(d => d.refLabTopic?.name)
                    .filter(d => d)
                    .join(", "),
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            search: { visible: () => false }
        }),
        createColumnInput({
            title: () => i18n.global.t("views.company.report.labReject.labPhysic"),
            dataIndex: "physic.analysiss.topics.refLabTopic.name",
            dataIndexValue: ({ record }) =>
                record.analysiss
                    .filter(d => d.refLabType?.key === "labPhysic")
                    .flatMap(d => d.topics)
                    .map(d => d.refLabTopic?.name)
                    .filter(d => d)
                    .join(", "),
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            search: { visible: () => false }
        })
    ];
    return columns;
};
